import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW4000Model } from './kymw4000.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { KYMW4001Component } from '../../kymw40/kymw4001/kymw4001.component';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { OutputPromotionPlanGoodsListService } from './api-services/output-promotion-plan-goods-list.service';
import { KYMW4000OutputModel } from './vo/kymw4000-output.model';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
// eslint-disable-next-line max-len
import { PromotionInfoComboBoxComponent } from '../../../commons/kymw02/combo-box/promotion-info-combo-box/promotion-info-combo-box.component';

/**
 * 週次プロモーション商品計画表画面を管理するクラス
 *
 * @export KYMW4000Component
 * @class KYMW4000Component
 */
@Component({
  selector: 'app-kymw4000',
  templateUrl: 'kymw4000.component.html',
  styleUrls: ['kymw4000.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW4000Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('cmb_Promotion', { static: true }) cmb_Promotion: PromotionInfoComboBoxComponent;

  // 親画面からの連携値
  param: any;

  kymw4000Model: KYMW4000Model = new KYMW4000Model();

  /**
   * Creates an instance of KYMW4000Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW4000Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private fileDownloadConfirmService: FileDownloadConfirmService,
    private outputPromotionPlanGoodsListService: OutputPromotionPlanGoodsListService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW4000';
  }

  /**
   * 出力ボタンを押下した時に呼び出される
   *
   * @memberof KYMW4000Component
   */
  public eventOutput_CLICKHandler(): void {
    const kymw4000OutputVO: KYMW4000OutputModel = new KYMW4000OutputModel();
    kymw4000OutputVO.startOrderCode = this.kymw4000Model.startOrderCode;
    kymw4000OutputVO.endOrderCode = this.kymw4000Model.endOrderCode;
    kymw4000OutputVO.promotionNo = this.kymw4000Model.promotionNo;

    // 週次プロモーション商品計画表出力API呼び出し
    this.outputPromotionPlanGoodsListService.execute(this.kymw4000Model, kymw4000OutputVO,
      (data: any) => this.outputPromotionPlanGoodsListServiceSuccessFunc(data));
  }

  /**
   * プロモーションボタンを押下した時に呼び出される
   *
   * @memberof KYMW4000Component
   */
  public eventPromotion_CLICKHandler(): void {
    // プロモーションマスタ一覧画面(モーダル)を表示する
    const componentRef = this.dialogService.openModal(KYMW4001Component);
    const instance = componentRef.componentInstance as KYMW4001Component;
    instance.parent = this;
    instance.closeFunction = () => {
      componentRef.close();

      // プロモーション情報コンボ最新化処理
      this.cmb_Promotion.updatePromotionInfo();
    };
  }

  /**
   * 週次プロモーション商品計画表出力API成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW4000Component
   */
  public outputPromotionPlanGoodsListServiceSuccessFunc(data: any) {
    // ファイル名の設定
    const fileName = '週次プロモーション商品計画表_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.zip';

    // ファイルダウンロード
    this.fileDownloadConfirmService.show(data.FileName, fileName);
  }

}
